<rask-container-block>
    <rask-header size="3">
        {{systemaktivitet.rubrik}}
        <ng-content></ng-content>
    </rask-header>
    <ng-container>
        <div class="body-text">
            <small>Visades {{systemaktivitet.datumFran | date:'yyyy-MM-dd'}} - {{systemaktivitet.datumTill | date:'yyyy-MM-dd'}}, Upplagt av {{systemaktivitet.iBy}}</small>
            <div [innerHtml]="systemaktivitet.meddelande | raskLinkifyFormat"></div>
        </div>
    </ng-container>
</rask-container-block>
